<template>
  <div class="orders">
    <v-table
      ref="table"
      name="ltl"
      :items="items"
      :row-height="30"
      :coreColumnDefs="coreColumnDefs"
      :defaultSort="{ prop: 'appt_date', order: 'descending' }"
      :getHeight="getHeight"
      @loadMore="$emit('loadMore')"
    />
  </div>
</template>
<script>
import Vue from "vue";

Vue.component("ltl-id", {
  props: { item: Object, options: Object },
  template: `
    <popup componentPath="components/html" width="900px" :pivot-y=0 :options="viewOrderOptions(item.id)">
      #{{item.id}}
    </popup>      
  `,
});

Vue.component("ltl-appt", {
  props: { item: Object, options: Object },
  template: `
    <div class="v-appt-time align-center">
      <container-appointment
        :id="item.id"
        :apptData="{ appt_date: item.appt_date, appt_start: item.appt_start, appt_end: item.appt_end, appt_editable: item.appt_editable }"
        :key="prefixKey('appt-time', item.id)"
      />
      <container-appt-confirm
        v-if="item.appt_confirmed_support"
        :id="item.id" 
        :confirmed="item.appt_confirmed"
        :editable="item.appt_confirmed_editable"
        :key="prefixKey('appt-cfm', item.id)"
      />
    </div>
  `,
});

Vue.component("ltl-priority", {
  props: { item: Object, options: Object },
  template: `
    <container-priority :item="{ id: item.id, priority: item.priority }" :key="prefixKey('priority', item.id)"/>
  `,
});

Vue.component("ltl-bols", {
  props: { item: Object, options: Object },
  template: `
    <div>
      <popup
        v-for="bol in item.bols" :key="bol.id"
        componentPath="components/html"
        width="900px"
        :pivot-y="0"
        :resizable="false"
        :options="{ url: '/bols/' + bol.id }">
        #{{bol.id}} {{bol.reference_no}}
      </popup>              
    </div>
  `,
});

Vue.component("ltl-customers", {
  props: { item: Object, options: Object },
  template: `
    <div><div v-for="customer in item.customers" :key="customer.id">{{customer.name}}</div></div>
  `,
});

import api from "@/default/utils/api";
export default {
  name: "LtlTable",
  mixins: [api],
  props: {
    items: {
      type: Array,
      required: true,
    },
    origin: {
      type: Boolean,
      default: true,
    },
    start: {
      type: Boolean,
      default: true,
    },
    loadTrip: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      coreColumnDefs: [
        {
          name: "ID",
          field: "id",
          width: 65,
          component: "ltl-id",
        },
        {
          name: "Hub",
          field: "hub.name",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Customers",
          field: "customers",
          width: "250",
          component: "ltl-customers",
        },
        {
          name: "Trailer No.",
          field: "container_no",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Type",
          field: "t_trailer_type",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Truck No.",
          field: "truck_no",
          width: 100,
          component: "v-table-column",
        },
        {
          name: "Appt. Time",
          field: "appt_date",
          width: "120",
          component: "ltl-appt",
        },
        {
          name: "PRI",
          field: "priority.value",
          width: "55",
          aliasName: "Priority",
          component: "ltl-priority",
        },
        {
          name: "BOLs",
          field: "bols",
          width: "120",
          component: "ltl-bols",
        },
        {
          name: "Trucker",
          field: "trucker",
          width: "150",
          component: "v-table-column",
        },
        {
          name: "Admin Comment",
          field: "last_admin_comment",
          width: "150",
          component: "v-table-column",
        },
      ],
    };
  },
  methods: {
    getHeight() {
      return document.querySelector("#app > .content").offsetHeight - 135;
    },
    scrollTop() {
      this.$refs.table.$refs.utable.pagingScrollTopLeft(0, 0);
    },
  },
};
</script>
